import { render } from "./ArgumentList.vue?vue&type=template&id=4121e582"
import script from "./ArgumentList.vue?vue&type=script&lang=js"
export * from "./ArgumentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__